import React, { Component } from 'react';
import { Button } from '@wordpress/components';

export default class Gmap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapKey : eaeGlobalVar.map_key,
            isLoading : 'false'
        };
    }
    saveGmapKey(){
        //console.log('click',this);
        //this.setState({isLoading : 'true'});
        this.props.set_status('true');
        jQuery.ajax({
            type: 'POST',
            url: eaeGlobalVar.ajax_url,
            data: {
                action : 'eae_save_gmap',
                mapkey : this.state.mapKey,
                nonce : eaeGlobalVar.nonce
            },
        })
            .done(function(data) {
                this.props.set_status('false');
                //this.setState({isLoading : 'false'});
            }.bind(this))
            .fail(function(jqXhr) {
                console.log('failed to register');
            });

    }
    render() {
        return[
            <div className="eae-gmap-wrapper">
                <form method="POST">
                    <table className="form-table">
                        <tbody>
                        <tr className="wts_eae_gmap_key">
                            <th scope="row">Google Map Key</th>
                            <td>
                                <input id="wts_eae_gmap_key" type="text" name="mapKey" className="regular-text" defaultValue={eaeGlobalVar.map_key} onChange={ (event) => (this.setState({ mapKey : event.target.value}))}/>
                                <p className="description"><a
                                    href="https://developers.google.com/maps/documentation/javascript/get-api-key"
                                    target="_blank">Click Here</a> to generate API KEY</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <Button className="eae-btn-save-setting" onClick={this.saveGmapKey.bind(this)}>
                        Save Changes
                    </Button>
                </form>
            </div>
            ]
    }
}
